<template>
  <div>

    <loading-page
      v-if="!loadingAccessTokenDone"
      text="Logging in..."
    ></loading-page>
    <v-container
      v-else-if="loadingAccessTokenDone"
      class="pa-0"
      style="height: 100%"
    >
      <!-- <v-container v-else class="pa-0" style="height: 100%"> -->
      <v-row
        no-gutters
        class="overflowY-auto"
        style="width: 100%; height: 100vh"
      >
        <v-col cols="12" xl="4" lg="6" md="7" sm="9" style="margin: auto">
          <v-row justify="center" class="mb-8">
            <v-img
              src="/img/dynamic-src-images/logos/SVG-logo.svg"
              :max-width="$vuetify.breakpoint.width > 390 ? '385' : '315'"
              height="171"
              contain
            ></v-img>
          </v-row>
          <v-card
            class="card-shadow mb-12 mx-5"
            style="background: #fff; border: 1px solid rgb(218, 220, 224, 0.5)"
          >
            <v-card-text class="simple-slow-opacityAN py-1">
              <v-row class="pb-2" justify="center">
                <v-col cols="6" sm="5">
                  <p
                    class="sign-in mb-0 pt-2"
                    style="margin-top: auto; color: #424242"
                  >
                    Sign in
                  </p>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="10" sm="8">
                  <v-form ref="loginForm" v-model="loginForm">
                    <v-text-field
                      class="text-field-text"
                      autofocus
                      light
                      dense
                      outlined
                      label="Username or e-mail"
                      :rules="[rules.required]"
                      autocomplete
                      v-model="credentials.username"
                      @keypress="keypressed"
                    ></v-text-field>
                    <v-text-field
                      class="text-field-text"
                      light
                      dense
                      outlined
                      label="Password"
                      type="password"
                      :rules="[rules.required]"
                      autocomplete
                      v-model="credentials.password"
                      @keypress="keypressed"
                    ></v-text-field>
                    <v-row v-if="error" justify="center">
                      <v-icon class="red--text mr-1" style="height: 20px" small
                        >fas fa-exclamation-circle</v-icon
                      >
                      <p
                        v-if="errorType == errorEnums.NETWORKERROR"
                        class="red--text mb-3"
                      >
                        Network error.
                      </p>
                      <p
                        v-else-if="errorType === errorEnums.ER401"
                        class="red--text mb-3 text-center"
                      >
                        Username or password are incorrect.
                      </p>
                      <p
                        v-else-if="errorType === errorEnums.CUSTOM_TIMEOUT"
                        class="red--text mb-3 text-center"
                      >
                        Request took too long, please try again.
                      </p>
                      <v-col v-else-if="sessionExpired" class="py-0">
                        <p class="red--text">
                          Your session has expired. Please sign in again.
                        </p>
                      </v-col>
                      <p v-else class="red--text mb-3">Something went wrong!</p>
                    </v-row>
                    <v-row justify="center">
                      <v-col
                        cols="11"
                        xl="4"
                        lg="6"
                        md="7"
                        sm="9"
                        class="text-center"
                      >
                        <v-btn
                          v-if="!loading || error"
                          @click="loginRemote"
                          color="primary"
                          >Sign In</v-btn
                        >
                        <div
                          v-else
                          style="width: 89px; height: 36px"
                          class="text-center mx-auto"
                        >
                          <v-progress-circular
                            class="mt-2"
                            indeterminate
                            color="primary"
                            :size="24"
                            :width="3"
                          ></v-progress-circular>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { ERRORS } from "../utilities/enums";
import { LoadingPage } from "../components/Default-Page-Components";
import { AuthenticationService, UserService } from "@/services/ApiService";
export default {
  name: "Login",
  components: { LoadingPage },
  data: () => ({
    loadingAnimationShowed: false,
    errorEnums: ERRORS,
    errorType: null,
    error: false,
    loginForm: true,
    wrongCredentials: false,
    loading: false,
    credentials: {
      password: "",
      username: "",
    },
    rules: {
      required: (v) => !!v || "Required",
    },
  }),
  methods: {
    keypressed(ev) {
      if (ev.charCode === 13 && ev.which === 13 && this.loginForm) {
        this.loginRemote();
      }
    },
    loginRemote() {
      let accessToken;
      this.error = false;
      this.loading = true;
      AuthenticationService.login(this.credentials)
        .then((r) => {
          accessToken = r.headers.authorization;
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${r.headers.authorization}`;
          return UserService.getUserInfo();
        })
        .then((r) => {
          this.setUserInfo(r.data);
          this.$emit("login", accessToken);
          setTimeout(() => {
            this.loading = false;
            this.error = false;
          }, 500);
        })
        .catch((er) => {
          console.error(er);
          this.loading = false;
          this.error = true;
          if(er.message && er.message.includes("timeout")) {
            this.errorType = ERRORS.CUSTOM_TIMEOUT
          }
          else if (er.message.search(ERRORS.NETWORKERROR) !== -1) {
            this.errorType = ERRORS.NETWORKERROR;
          } else if (er.message.search(ERRORS.ER500) !== -1) {
            this.errorType = ERRORS.ER500;
          } else if (er.message.search(ERRORS.ER401) !== -1) {
            this.errorType = ERRORS.ER401;
          } else {
            this.errorType = null;
          }
        });
    },
    ...mapMutations(["setUserInfo"]),
  },
  watch: {
    loadingAccessTokenDone() {
      this.$forceUpdate();
    },
  },
  props: {
    sessionExpired: {
      type: Boolean,
      default: false,
    },
    loadingAccessTokenDone: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style>
.text-field-text .v-input__control label {
  font-family: "Roboto", sans-serif !important;
  font-weight: 300 !important;
  color: grey;
  letter-spacing: 0.01rem;
}
</style>
<style scoped>

@keyframes slideDealio {
  0% {
    margin-right: 0%;
    opacity: 1;
  }
  /* 100% {
    margin-right: 80%;
    opacity: 0.5;
  } */
  70% {
    opacity: 0.1;
  }
  100% {
    margin-right: 120%;
    opacity: 0;
  }
}
.dealio_sliding_animation {
  animation-duration: 3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  /* animation-iteration-count: infinite; */
  animation-delay: 2.7s;
  animation-name: slideDealio;
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.4, 0.1, 0.01, 1.5);
  /* animation-timing-function: cubic-bezier(0.1, -0.15, 0.2, 0); */
  /* height: 150px;
  width: 150px; */
  margin-right: 0%;
  /* margin: auto; */
}

.card-shadow {
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}
.sign-in {
  letter-spacing: -0.015625em !important;
  font-weight: 300 !important;
  font-family: "Roboto", sans-serif !important;
  font-size: 29px;
  height: 44px !important;
  text-align: center;
}
</style>
